/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Status_CompleteInputs */



/**
* | output |
* | --- |
* | "Publishing Workflow Complete" |
*
* @param {Work_Order_Publish_Status_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_status_complete = /** @type {((inputs?: Work_Order_Publish_Status_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Status_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Flux de publication terminé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veröffentlichungs-Workflow abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Flusso di lavoro di pubblicazione completato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Процесс публикации завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Flujo de trabajo de publicación completo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发布工作流程已完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("公開ワークフローの完了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रकाशन कार्यप्रवाह पूर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fluxo de trabalho de publicação concluído")
	return /** @type {LocalizedString} */ ("Publishing Workflow Complete")
});